import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { OpenHomeTime } from '@classifieds-sell/datalayer';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-summary-page-open-homes-section',
    templateUrl: './summary-page-open-homes-section.component.html',
    styleUrls: ['./summary-page-open-homes-section.component.scss']
})
export class SummaryPageOpenHomesSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    private _destroyed$: Subject<void> = new Subject<void>();

    openHomeTimes: OpenHomeTime[] = [];

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.openHomeTimes =
                this.draftData.propertyInformation.openHomeTimes || [];
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
